// extracted by mini-css-extract-plugin
export default {"backBtnStyle":"backBtnIconStyles_backBtnStyle__5POBz"};